var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("tag people Demo")]),_c('div',{staticStyle:{"width":"300px","height":"300px","position":"absolute","left":"100px","top":"200px"}},[_c('tag-group',{staticStyle:{"background":"red"},attrs:{"image":_vm.image}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }